document.addEventListener('DOMContentLoaded', () => {
  // Function to initialize marquee
  const initMarquee = (section) => {
    const track = section.querySelector('[data-marque-track]');
    if (!track) return;

    const textElements = track.querySelectorAll('.comp-marque-text');
    if (textElements.length === 0) return;

    // Calculate width of one text element
    const textWidth = textElements[0].offsetWidth;
    
    // Set track width to double the text width for seamless looping
    track.style.width = `${textWidth * 2}px`;
    
    // Get speed from section settings (default to 20s)
    const speed = section.dataset.speed || 20;
    
    // Create unique animation name based on section ID
    const animationName = `marquee-scroll-${section.dataset.sectionId}`;
    
    // Create or update style element for animation
    let style = document.getElementById(`marquee-style-${section.dataset.sectionId}`);
    if (!style) {
      style = document.createElement('style');
      style.id = `marquee-style-${section.dataset.sectionId}`;
      document.head.appendChild(style);
    }
    
    // Define the animation
    style.textContent = `
      @keyframes ${animationName} {
        0% { transform: translateX(0); }
        100% { transform: translateX(-${textWidth}px); }
      }
    `;
    
    // Apply the animation
    track.style.animation = `${animationName} ${speed}s linear infinite`;
    
    // Handle Shopify editor
    if (window.Shopify?.designMode) {
      section.addEventListener('shopify:section:select', () => {
        track.style.animationPlayState = 'paused';
      });
      
      section.addEventListener('shopify:section:deselect', () => {
        track.style.animationPlayState = 'running';
      });
    }
  };

  // Initialize all marquees on page load
  document.querySelectorAll('[data-section-id].comp-marque-text-container').forEach(section => {
    // Add data-speed attribute from settings
    const speedSetting = section.querySelector('[data-section-settings]');
    if (speedSetting) {
      const settings = JSON.parse(speedSetting.textContent);
      section.dataset.speed = settings.speed || 20;
    } else {
      section.dataset.speed = 20;
    }
    
    initMarquee(section);
  });

  // Reinitialize when sections are loaded in editor
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-section-id].comp-marque-text-container');
      if (section) initMarquee(section);
    });
  }
});